import { render, staticRenderFns } from "./talking.vue?vue&type=template&id=de32ab76&scoped=true&"
import script from "./talking.vue?vue&type=script&lang=js&"
export * from "./talking.vue?vue&type=script&lang=js&"
import style0 from "./talking.vue?vue&type=style&index=0&id=de32ab76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de32ab76",
  null
  
)

export default component.exports